import { render, staticRenderFns } from "./EditPassword.vue?vue&type=template&id=42b68f4c&scoped=true"
import script from "./EditPassword.vue?vue&type=script&lang=js"
export * from "./EditPassword.vue?vue&type=script&lang=js"
import style0 from "./EditPassword.vue?vue&type=style&index=0&id=42b68f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b68f4c",
  null
  
)

export default component.exports